import React, { Component } from 'react'
import firebase from 'firebase'
import { toast } from 'react-toastify'
import { remove, find } from 'lodash'
import moment from 'moment'

import './styles/style.css'

class PhotoLoader extends Component {

    constructor(props) {
        super(props)

        this.state = {
            filesList: (this.props.filesList && Array.isArray(this.props.filesList)) ? this.props.filesList : [],
            file: null,
            progress: 0
        }
    }

    fileSelect(e) {
        const input = e.nativeEvent.target
        const files = input.files

        if (files.length === 1 && files[0].size > 3000000) {
            toast.error(`Размер файла превышает 3 mb`, {
                position: toast.POSITION.TOP_RIGHT
            })
        } else if (files.length === 1) {
            this.setState({
                file: files[0]
            }, this.fileUpload.bind(this))
        }
    }

    fileUpload() {
        const storageRef = firebase.storage().ref()
        const file = this.state.file
        const metadata = {
            'contentType': file.type
        }
        const id = `${file.size}_${file.lastModified}_${moment().format('x')}`
        // const thumbId = `thumb_${id}`

        let uploadTask = storageRef.child('files/' + id).put(file, metadata)
        uploadTask.on('state_changed', (snapshot) => {
            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            this.setState({
                progress: progress
            })
        }, (error) => {
            toast.success(`Произошла ошибка!`, {
                position: toast.POSITION.TOP_RIGHT
            })
        }, () => {
            const url = uploadTask.snapshot.downloadURL
            // const thumbUrl = url.replace(id, thumbId)
            const thumbUrl = url
            const newList = this.state.filesList.slice(0)
            const findMain = find(newList,{isMain: true})

            const isMain = (newList.length === 0 || !findMain) ? true : false

            newList.push({
                id: id,
                url: url,
                thumbUrl: thumbUrl,
                isMain: isMain
            })
            this.setState({
                filesList: newList
            }, () => {
                toast.success(`Файл успешно загружен`, {
                    position: toast.POSITION.TOP_RIGHT
                })
                if (this.props.onLoad) {
                    this.props.onLoad(this.state.filesList)
                }
            })
        })

    }

    deletePhoto(item) {
        const that = this
        const storageRef = firebase.storage().ref()
        let fileRef = storageRef.child(`files/${item.id}`)

        fileRef.getMetadata().then(function (metadata) {
            fileRef.delete().then(function () {
                let newArray = that.state.filesList.slice(0)

                remove(newArray, (n) => {
                    return n.id === item.id
                })
                that.setState({
                    filesList: newArray
                }, () => {
                    if (that.props.onLoad) {
                        that.props.onLoad(that.state.filesList)
                    }
                })
                toast.success(`Файл успешно удален`, {
                    position: toast.POSITION.TOP_RIGHT
                })
            }).catch(function (error) {
                console.log(error)
                toast.error(`Произошла ошибка`, {
                    position: toast.POSITION.TOP_RIGHT
                })
            })
        }).catch(function (error) {
            let newArray = that.state.filesList.slice(0)

            remove(newArray, (n) => {
                return n.id === item.id
            })
            that.setState({
                filesList: newArray
            }, () => {
                if (that.props.onLoad) {
                    that.props.onLoad(that.state.filesList)
                }
            })
            toast.success(`Файл успешно удален`, {
                position: toast.POSITION.TOP_RIGHT
            })
        })

    }

    setMainPhoto(photo) {
        const that = this
        const newList = this.state.filesList.map((item, i) => {
            if (item.id === photo.id) {
                return { ...item, isMain: true }
            } else {
                return { ...item, isMain: false }
            }
        })

        that.setState({
            filesList: newList
        }, () => {
            if (that.props.onLoad) {
                that.props.onLoad(that.state.filesList)
            }
        })


    }

    render() {

        return (
            <div className="PhotoLoaderWrapper">
                <div className="FilesList">
                    {this.state.filesList.map((item, i) => {
                        return (
                            <div className="FilesListItemWrapper" key={`FilesListItem${i}`}>
                                <div style={{ backgroundImage: `url("${item.url}")` }} className="FilesListItem" key={`FilesListItem${i}`}>
                                    <div className="FilesListItemControls">
                                        <div className="FilesListItemControlsWrapper">
                                            <div className="FilesListItemControlsDeleteButton" onClick={this.deletePhoto.bind(this, item)} />
                                            <div className={`FilesListItemControlsSelectButton${item.isMain ? ' Active' : ''}`} onClick={this.setMainPhoto.bind(this, item)} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                    <label htmlFor="file" className="PhotoLoaderWrapperLabel">
                        <div className="PregressOverlay" style={{ width: `${this.state.progress}%` }} />
                    </label>
                </div>

                <input
                    type="file"
                    name="file"
                    id="file"
                    accept="image/*"
                    className="inputfile"
                    onChange={this.fileSelect.bind(this)}
                    multiple={false}
                />
            </div>
        )
    }
}

export default PhotoLoader


// WEBPACK FOOTER //
// ./src/Components/PhotoLoader/index.js